import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BusinessContactForm, IndividualContactForm } from "../components/common/ReusableContactForm";
import Footer from "../components/Footer";

const Contact: React.FC = () => {
    const location = useLocation();
    const [contactType, setContactType] = useState<"individual" | "company">("individual");

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const typeParam = queryParams.get("type");
        
        if(typeParam === "company") {
            setContactType("company");
        } else {
            setContactType("individual");
        }
      }, [location.search]);

      const renderForm = () => {

      switch (contactType) {
        case "company":
          return <BusinessContactForm />;
        case "individual":
        default:
          return <IndividualContactForm/>;
      }
    };

    return(
      <>
      {renderForm()}
      <Footer 
              buttonText="" 
              buttonLink=""
              ctaText={{
                prefix: '',
                highlight1: '',
                middle: '',
                highlight2: '',
                suffix: ''
              }}
            />
      </>
    )
}

export default Contact;